var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6634 2.49927C13.1029 2.50553 13.5221 2.68518 13.8297 2.99911L16.9953 6.16475C17.3092 6.47237 17.4889 6.89157 17.4952 7.33104V15.8283C17.4952 16.2702 17.3196 16.694 17.0072 17.0064C16.6947 17.3189 16.2709 17.4944 15.829 17.4944H4.16613C3.72424 17.4944 3.30046 17.3189 2.988 17.0064C2.67554 16.694 2.5 16.2702 2.5 15.8283V4.1654C2.5 3.72351 2.67554 3.29973 2.988 2.98727C3.30046 2.67481 3.72424 2.49927 4.16613 2.49927H12.6634Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1627 17.4944V11.6629C14.1627 11.442 14.0749 11.2301 13.9187 11.0738C13.7625 10.9176 13.5506 10.8298 13.3296 10.8298H6.6651C6.44415 10.8298 6.23226 10.9176 6.07603 11.0738C5.9198 11.2301 5.83203 11.442 5.83203 11.6629V17.4944",
    stroke: "#1A1A1A",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 2.49927V5.83153C5.83203 6.05247 5.9198 6.26436 6.07603 6.42059C6.23226 6.57682 6.44415 6.66459 6.6651 6.66459H12.4965",
    stroke: "#1A1A1A",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.815c3c623f8eb45c8a0b8a096fd421d4.svg";
export { ForwardRef as ReactComponent };